import React from "react";

/**
 * ScreenBurner — persistent brand watermark ("channel bug"), top-right,
 * ~80% opacity, pointer-events disabled so it never blocks UI. Rendered
 * once by RoboticsShell so every /robotics/* page inherits it.
 */
export default function ScreenBurner({ variant = "bold" }) {
  const gold = "#f4c46a";
  return (
    <div className="rbx-burner" aria-hidden="true" data-testid="rbx-burner" data-variant={variant}>
      <span className="rbx-burner__mark">
        {/* Small satellite motif — matches the Clarke Orbit heritage */}
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="3" fill={gold} />
          <path d="M12 4 L14 8 L10 8 Z" fill={gold} opacity="0.85" />
          <path d="M12 20 L14 16 L10 16 Z" fill={gold} opacity="0.85" />
          <ellipse cx="12" cy="12" rx="10" ry="4" stroke={gold} strokeOpacity="0.5"
                   strokeWidth="1" strokeDasharray="2 3" fill="none" />
        </svg>
      </span>
      <span className="rbx-burner__text">FutureTec · Robotics</span>
    </div>
  );
}
